  // Scroll-reveal for proof charts. Gated on JS + IO support + motion preference:
  // without body.anim the bars render at full width, so nothing is hidden if this never runs.
  (function () {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    document.body.classList.add('anim');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.3 });
    document.querySelectorAll('.poster-grid, .dose-gap-band, .study-chart, .base-band, .six-card, .nr, .m6-grid, .tk-route, .mf-band, .tkl').forEach(function (el) { io.observe(el); });
  })();

  window.dataLayer = window.dataLayer || [];
  document.querySelectorAll('[data-cta]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var sel = document.querySelector('.plan.sel');
      window.dataLayer.push({ event: 'cta_clicked', location: el.getAttribute('data-cta'), plan: sel ? sel.getAttribute('data-plan') : null });
    });
  });

  (function () {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('.plan'));
    var form = document.getElementById('minutes-buy');
    var spInput = document.getElementById('minutes-selling-plan');
    var rtInput = document.getElementById('minutes-return-to');
    var riskLine = document.querySelector('.buybox .risk[data-plan-risk]');
    function applyPlan(plan) {
      if (!form) return;
      var btn = form.querySelector('button[type=submit]');
      var hasPlan = !!form.getAttribute('data-selling-plan');
      var hasVariant = !!form.querySelector('[name=id]').value;
      if (plan === 'subscribe') {
        // fail closed: no selling plan yet => the subscribe promise cannot be honoured, so the button is inert
        spInput.value = form.getAttribute('data-selling-plan') || ''; spInput.disabled = !hasPlan;
        rtInput.value = form.getAttribute('data-return-subscribe');
        if (btn) btn.disabled = !(hasPlan && hasVariant);
        if (riskLine) riskLine.textContent = riskLine.getAttribute('data-risk-subscribe');
      } else {
        spInput.value = ''; spInput.disabled = true;
        rtInput.value = form.getAttribute('data-return-onetime');
        if (btn) btn.disabled = !hasVariant;
        if (riskLine) riskLine.textContent = riskLine.getAttribute('data-risk-onetime');
      }
    }
    var ctaLabels = { subscribe: 'Try 28 nights, Subscribe & Save, $29.99 first bag', onetime: 'Try 28 nights, One-time bag, $64.99' };
    var ctaTexts = { subscribe: 'Try 28 nights · $29.99', onetime: 'Try 28 nights · $64.99' };
    function select(tile) {
      tiles.forEach(function (t) { t.classList.remove('sel'); t.setAttribute('aria-checked', 'false'); t.setAttribute('tabindex', '-1'); });
      tile.classList.add('sel'); tile.setAttribute('aria-checked', 'true'); tile.setAttribute('tabindex', '0');
      var plan = tile.getAttribute('data-plan');
      var cta = document.querySelector('[data-cta="buybox"]');
      applyPlan(plan);
      if (cta) {
        cta.setAttribute('aria-label', ctaLabels[plan] || 'Try 28 nights');
        cta.textContent = ctaTexts[plan] || 'Try 28 nights';
        cta.setAttribute('data-plan-selected', plan);
      }
      var sticky = document.querySelector('[data-cta="stickybar"]');
      if (sticky) {
        sticky.textContent = plan === 'onetime' ? 'One-time bag · $64.99 →' : 'Save $50 · first bag $29.99 →';
      }
      window.dataLayer.push({ event: 'offer_selected', plan: plan });
    }
    applyPlan('subscribe');
    tiles.forEach(function (tile, i) {
      tile.setAttribute('tabindex', tile.classList.contains('sel') ? '0' : '-1');
      tile.addEventListener('click', function () { select(tile); });
      tile.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(tile); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); var n = tiles[(i + 1) % tiles.length]; select(n); n.focus(); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); var p = tiles[(i - 1 + tiles.length) % tiles.length]; select(p); p.focus(); }
      });
    });
  })();

  (function () {
    var fired = {};
    function depth() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h <= 0) return;
      var pct = Math.round((window.scrollY / h) * 100);
      [25, 50, 75, 100].forEach(function (m) {
        if (pct >= m && !fired[m]) { fired[m] = true; window.dataLayer.push({ event: 'scroll_depth', depth: m }); }
      });
    }
    window.addEventListener('scroll', depth, { passive: true });
  })();

  (function () {
    var heroCtas = document.querySelector('.hero-ctas');
    var buyCta = document.querySelector('[data-cta="buybox"]');
    var bar = document.getElementById('stickybar');
    if (!heroCtas || !buyCta || !bar) return;
    if (!('IntersectionObserver' in window)) { bar.classList.add('show'); bar.setAttribute('aria-hidden', 'false'); return; }
    var heroCtaGone = false, buyCtaVisible = false;
    function update() {
      var show = heroCtaGone && !buyCtaVisible;
      bar.classList.toggle('show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) { bar.removeAttribute('inert'); } else { bar.setAttribute('inert', ''); }
      document.body.classList.toggle('bar-visible', show);
    }
    new IntersectionObserver(function (entries) { heroCtaGone = !entries[0].isIntersecting; update(); }).observe(heroCtas);
    new IntersectionObserver(function (entries) { buyCtaVisible = entries[0].isIntersecting; update(); }).observe(buyCta);
    update();
  })();
